import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["children", "className", "imageTag", "imageAttributes", "linkTag", "linkAttributes", "linkText"];
import React from 'react';
import classNames from 'classnames';
var BannerWithOverlay = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BannerWithOverlay, _React$Component);
  function BannerWithOverlay() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = BannerWithOverlay.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      className = _this$props.className,
      ImageTag = _this$props.imageTag,
      imageAttributes = _this$props.imageAttributes,
      LinkTag = _this$props.linkTag,
      linkAttributes = _this$props.linkAttributes,
      linkText = _this$props.linkText,
      attrs = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var classes = classNames('banner', 'position-relative', 'text-center', 'p-4', 'overflow-hidden', className);
    return /*#__PURE__*/React.createElement("section", _extends({
      className: classes
    }, attrs), /*#__PURE__*/React.createElement("div", {
      className: "banner__wrapper d-flex align-items-center w-100 h-100"
    }, imageAttributes && /*#__PURE__*/React.createElement(ImageTag, _extends({
      className: "banner__image"
    }, imageAttributes)), children && /*#__PURE__*/React.createElement("div", {
      className: "banner__content position-relative mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "banner__content__container"
    }, children))), linkAttributes && /*#__PURE__*/React.createElement(LinkTag, _extends({
      className: "banner__link stretched-link",
      title: linkText
    }, linkAttributes), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, linkText)));
  };
  return BannerWithOverlay;
}(React.Component);
export { BannerWithOverlay as default };
BannerWithOverlay.defaultProps = {
  imageTag: 'img',
  linkTag: 'a'
};